module.exports = __webpack_public_path__ + "static/img/ross_noble_ani_extended_size_00016-fs8.99ba5c2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/animation/ross_noble_ani_extended_size_00016-fs8.png
// module id = 169
// module chunks = 0